import React, { useState, useEffect } from "react";
import { useController } from "react-hook-form";
import { StyledWrapper } from "./timeField.style";

import NumberLabeled from "../../../../../genericInputFields/numberLabeled/numberLabeled.component";

const TimeField = ({ name, required, minValue }) => {
  const {
    field,
    fieldState: { error },
  } = useController({
    name,
    rules: {
      required: {
        value: required,
        message: "This field is required",
      },
      min: {
        value: minValue,
        message: `Minimum value is ${Math.floor(minValue / 3600)}h ${Math.ceil((minValue % 3600) / 60)}min`,
      },
    },
  });
  const [fieldValue, setFieldValue] = useState(field.value || minValue || 0);

  useEffect(() => {
    field.onChange(fieldValue);
  }, [fieldValue]);

  const handleHoursChange = (val) => {
    setFieldValue((prev) => parseInt(val) * 3600 + (prev % 3600));
  };

  const handleMinutesChange = (val) => {
    const hours = Math.floor(fieldValue / 3600);
    const incoming = parseInt(val);
    setFieldValue(hours * 3600 + incoming * 60);
  };

  return (
    <StyledWrapper>
      <input
        type="hidden"
        name={field.name}
        value={fieldValue}
        ref={field.ref}
      />
      <div>
        Time limit:
        <NumberLabeled
          value={Math.floor(fieldValue / 3600)}
          minValue={0}
          stepValue={1}
          onChange={(e) => handleHoursChange(e.target.value)}
          onBlur={field.onBlur}
        />
        h{` `}
        <NumberLabeled
          value={Math.floor((fieldValue % 3600) / 60)}
          minValue={0}
          maxValue={59}
          stepValue={1}
          onChange={(e) => handleMinutesChange(e.target.value)}
          onBlur={field.onBlur}
        />
        min
      </div>
      <span className="error">{error?.message || ""}</span>
    </StyledWrapper>
  );
};

export default TimeField;
